module.exports = __webpack_public_path__ + "01_medium_black.f9f7b70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_medium_black.png
// module id = dXN5
// module chunks = 0